import { getCommonWidget } from '../dashWidgetHelper'
import { commonWidgets, BYD_DEFAULT_SCALE_3_COLORS } from './commonWidgetsByd'


export default {
  title: 'CXO Venta/Postventa Dashboard',
  description: 'Dashboard de CXO Venta/Postventa',
  backgroundClassName: (filters) => 'epsilon-hero-bg',
  widgets: (filters: FiltersUI) => [
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'textAnalysis',
      title: 'Análisis de sentimientos',
      indicator: 'SENTIMENT',
      position: [0, 0],
      size: [4, 4],
      extraConfigs:{
             colors: BYD_DEFAULT_SCALE_3_COLORS
           }
    }),

  ],
} as DasboardConfig
